/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */

import LiteYouTubeEmbed from 'react-lite-youtube-embed';
// import 'videojs-contrib-quality-levels';
// import 'videojs-http-source-selector';
// import 'videojs-youtube';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

// ----------------------------------------------------------------------

export function PreviewYoutube({ videoId }) {

  return <LiteYouTubeEmbed
    id={videoId}
  />;

  // const playerRef = useRef(null);

  // useEffect(() => {
  //   if (!playerRef.current) {

  //     const options = {
  //       techOrder: ["youtube"],
  //       playbackRates: [0.5, 1, 1.5, 2],
  //       fluid: true,
  //       fill: true,
  //       responsive: true,
  //       posterImage: true,
  //       autoplay: autoplay,
  //       preload: 'auto',
  //       "youtube": { "ytControls": 2 },
  //       sources: [{ "type": "video/youtube", "src": `https://www.youtube.com/watch?v=${videoId}` }],
  //     };

  //     playerRef.current = videojs('video_2', options);
  //   } else {
  //     const player = playerRef.current;
  //     player.src({ "type": "video/youtube", "src": `https://www.youtube.com/watch?v=${videoId}` });
  //     player.controls(false);
  //   }
  // }, [videoId]);

  // useEffect(() => {
  //   const player = playerRef.current;

  //   return () => {
  //     if (player && !player.isDisposed()) {
  //       player.dispose();
  //       playerRef.current = null;
  //     }
  //   };
  // }, [playerRef]);

  // return (
  //   <video id="video_2" className="video-js vjs-default-skin" />
  // );
}
